export default {
  WORKSTEPS_SCROLL_ALIGN: true,
  ZOOM_TO_ACTIVE_WORKSTEP: process.env.REACT_APP_ENV !== 'testcafe',
  CACHE_PNIDS: !process.env.JEST_WORKER_ID,
};
